import {useInfiniteQuery, useMutation, useQuery} from "react-query"
import axios from "axios"
import {useState} from "react";
const localhost = window.location.hostname === "localhost"
const auth =  localhost ? {auth: {username: 'DevAnnie', password: 'JLdlVR1cTvUuRrjpNxwg'}} : null
// const offline = true
export function AuthCheck() {
    return useQuery("auth", async () => {
        //if (offline) return offlineData['authData']
        const { data } = await axios.post(
            "/api/v2/auth.php",
            {
                "ReturnTo":window.location.href
            }
        )
        return data
    }, {
        retry: false
    })
}

export function GetUser(user) {
    return useQuery("user"+user, async () => {
        //if (offline) return offlineData['userData']
        const { data } = await axios.get(
            "/api/v2/annieuser.php/"+user,
            auth
        )
        return data
    })
}

export function GetStatsTranslations(language) {
    const lang = language ? "?language="+language : ""
    return useQuery("statsTranslations"+lang, async () => {
        //if (offline) return offlineData['statsTranslations']
        const { data } = await axios.get(
            "/api/v2/translation.php/stats"+lang,
            auth
        )
        return data
    })
}

export function GetGeneralTranslations(language) {
    const lang = language ? "?language="+language : ""
    return useQuery("generalTranslations"+lang, async () => {
        //if (offline) return offlineData['generalTranslations']
        const { data } = await axios.get(
            "/api/v2/translation.php/general"+lang,
            auth
        )
        return data
    })
}

export function GetStats(campaigns = [], locations = [], degrees = [], groups = [], surveys = [], useCases = [], dateRange = []) {
    const arrayToQueryParam = (paramName, array) =>
        array.map(value => `${paramName}=${encodeURIComponent(value)}`).join('&')

    const campaignQuery = campaigns.length > 0 ? arrayToQueryParam('campaign', campaigns) : ''
    const useCasesQuery = useCases.length > 0 ? arrayToQueryParam('usecase', useCases) : ''
    const surveyQuery = surveys.length > 0 ? arrayToQueryParam('survey', surveys) : ''
    const locationQuery = locations.length > 0 ? arrayToQueryParam('location', locations) : ''
    const degreeQuery = degrees.length > 0 ? arrayToQueryParam('degree', degrees) : ''
    const groupQuery = groups.length > 0 ? arrayToQueryParam('group', groups) : ''
    const dateRangeQuery = dateRange.length > 0 ? arrayToQueryParam('daterange', dateRange) : ''

    const queryParams = [campaignQuery, surveyQuery, useCasesQuery, locationQuery, degreeQuery, groupQuery, dateRangeQuery]
        .filter(param => param !== '')
        .join('&')

    const query = queryParams ? `?${queryParams}` : ''

    return useQuery("surveyStatistics"+query, async () => {
        //if (offline) return offlineData['statsData']
        const { data } = await axios.get(
            "/api/v2/surveystatistics.php"+query,
            auth
        )
        return data
    })
}

export function GetStatsConfig() {
    return useQuery("statsConfig", async () => {
        //if (offline) return offlineData['statsConfig']
        const { data } = await axios.get(
            "/api/v2/config.php/stats/config",
            auth
        )
        return data
    })
}

export function GetSelectOptions() {
    return useQuery("selectables", async () => {
        //if (offline) return offlineData['selectOptions']
        const { data } = await axios.get(
            "/api/v2/selectables.php",
            auth
        )

        // Convert all values to strings
        const stringifiedData = {}
        for (const key in data) {
            if (Array.isArray(data[key])) {
                stringifiedData[key] = data[key].map(item => String(item))
            } else {
                stringifiedData[key] = data[key]
            }
        }

        return stringifiedData
    })
}

export function GetFollowupSentiments() {
    return useQuery("followupSentiments", async () => {
        //if (offline) return offlineData['followupresult']
        const { data } = await axios.get(
            "/api/v2/codes.php/followupresult",
            auth
        )
        return data
    })
}

export function GetFollowupTemplates() {
    return useQuery("followupTemplates", async () => {
        //if (offline) return offlineData['followutemplates']
        const { data } = await axios.get(
            "/api/v2/followuptemplates.php",
            auth
        )
        return data
    })
}

export function GetArchivedAndFinishedSurveys() {
    const statusQuery = "?status=ARCHIVED&status=FINISHED"
    return useQuery("surveys"+statusQuery, async () => {
        const { data } = await axios.get(
            "/api/v2/survey.php"+statusQuery,
            auth
        )
        return data
    })
}

export function GetInstanceLanguage() {
    return useQuery("instanceLanguage", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/language",
            auth
        )
        return data
    })
}

export function GetLanguageOptions() {
    return useQuery("languageOptions", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/languages",
            auth
        )
        return data
    })
}

export function GetUseCases() {
    return useQuery("useCases", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/usecase",
            auth
        )
        return data
    })
}

export function GetCustomerSegment() {
    return useQuery("customerSegment", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/ui/customersegment",
            auth
        )
        return data
    })
}
